{
  "title": "AirPlx",
  "message": "We are currently undergoing scheduled maintenance. AirPlx is scheduled to be back online at {{endTime}}."
}
